import React, { useEffect } from "react";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router";
import { authRoutes, publicRoutes } from "./router.link";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import Login from "../auth/login/login";
import { PrivateRoute } from "../../core/common/context/PrivateRouteContext";
import Error404 from "../pages/error/error-404";

const ALLRoutes: React.FC = () => {

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token && (location.pathname === "/" || location.pathname === "/login")) {
      navigate("/lead-dashboard");
    }
  }, [location.pathname]);

  return (
    <>
      <Routes>
        {/* <Route path="/network-error" element={<Error404 />} /> */}

        <Route path="/login" element={<Login />} />
        <>
          <Route element={
            <PrivateRoute>
              <Feature />
            </PrivateRoute>
          }>
            {publicRoutes.map((route, idx) => (
              <Route path={route.path} element={route.element} key={idx} />
            ))}
          </Route>

          <Route element={
            <PrivateRoute>
              <AuthFeature />
            </PrivateRoute>
          }>
            {authRoutes.map((route, idx) => (
              <Route path={route.path} element={route.element} key={idx} />
            ))}
          </Route>
        </>
      </Routes>
    </>
  );
};

export default ALLRoutes;

